import styled from 'styled-components/macro'
import { animated } from '@react-spring/web'


// Styled components
export const Container = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;


export const Banner = styled.div`
  pointer-events: none;
  position: fixed;
  bottom: 25px;
  width: 100%;
  display: ${({ hideAos }) => hideAos ? 'flex' : 'none'};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 120;
  & > * {
    margin-left: 40%;
  }

  & > div {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
  }

  & > div > * {
    margin: 0 10px;
  }

  & > div > div {
    width: 100px;
    
  }

  & > div > div > h3 {
    color: #0d5274;
    font-size:14px;
    opacity: 0;
    transform: translateY(20px);
    animation: fadeInDown 0.5s ease forwards;
    text-align:center;
  }

  & > div > div:first-of-type > h3 {
    animation-delay: 0.3s;
  }

  & > div > div:nth-of-type(2) > h3 {
    animation-delay: 0.4s;
  }

  & > div >div:last-of-type > h3 {
    animation-delay: 0.5s;
  }

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
export const Thumbnail = styled.img`
  width: 100px;
  height: auto;
  cursor: pointer;
  pointer-events:all;
  border-top: 1px solid rgba(13, 82, 116, .2);
  border-left: 1px solid rgba(13, 82, 116, .2);
  border-right: 1px solid rgba(13, 82, 116, .2);
  border-bottom: ${({ active }) => active ? '2px solid rgba(13, 82, 116, 1)' : '2px solid rgba(13, 82, 116, 0.0)'};
  transition: border-bottom 300ms;
`;

export const Overlay = styled(animated.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(220, 220, 220, 0.4);
  z-index: 100;
`;

export const Image = styled(animated.img)`
  position: fixed;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 90%;
  max-height: 90%;
  border: 2px solid #fff;
  cursor: pointer;
  z-index: 110;

`;

export const CloseButton = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 30px;
  height: 30px;
  background-color: #fff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  cursor: pointer;
`;

export const BannerText = styled.div`
  opacity: ${({ active }) => active ? 1 : .4};
  transition: opacity 300ms;
`;